module.exports = __webpack_public_path__ + "static/media/TH5.2460a7b6.jpg";